export default __webpack_public_path__ + "static/media/avatar_ben_leonard.4caebbc9.svg";